var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.touch,{tag:"component",attrs:{"isEdit":_vm.isEdit,"editId":_vm.editId,"letDelete":_vm.letDelete,"preloadedItem":_vm.preloadedItem},on:{"delete":()=>{_vm.$emit("delete")},"exit":arg=>{_vm.$emit("exit", arg)},"newInput":newVal => { _vm.$emit('newInput', newVal) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }